import React from "react";
import styled from "styled-components";
import useUserInfoCard from "components/Mypage/Main/UserInfoCard/useUserInfoCard";

function LnbUserInfoCard() {
  const { userData } = useUserInfoCard();

  return (
    <Box>
      {userData.thumbnail && <img src={userData.thumbnail} alt="profile" />}
      <NameSection>
        <h2>
          {userData.type === "전문가"
            ? userData.agencyName
            : userData.type === "병/의원"
            ? userData.hospitalName
            : userData.name}
        </h2>

        <div className="role-label">{userData.type}</div>
      </NameSection>
    </Box>
  );
}

export default LnbUserInfoCard;

const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  row-gap: 0.8rem;
  padding: 1.6rem;
  background-color: ${(props) => props.theme.colors.white};

  .phone,
  .email {
    ${(props) => props.theme.fonts.rg15};
    color: ${(props) => props.theme.colors.gray[600]};
  }
`;

const NameSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  ${(props) => props.theme.fonts.bd18};

  h2 {
  }

  .role-label {
    text-wrap: nowrap;
    display: flex;
    padding: 0.2rem 0.8rem;
    height: 2.8rem;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.colors.gray[100]};
    border-radius: 8px;
    color: ${(props) => props.theme.colors.gray[700]};
    ${(props) => props.theme.fonts.rg14};
  }
`;
